import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from "react";
import Box from "@mui/material/Box";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import { DataGrid } from "@mui/x-data-grid";
import { defaultOption } from "constants/ui/options";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllMasterBrand } from "../redux/handlers/master/getAllMasterBrand.handler";
import { getAllMasterMainCategory } from "../redux/handlers/master/getAllMasterMainCategory.handler";
import { getAllProductPrice } from "../redux/handlers/logic/getAllProductPrice.handler";
import { debounce } from "@mui/material";
import { getUnitCost, getVatByMstCategoryPrice, mappingProductPriceData } from "utils/HelperFunction";
import { nanoid } from "@reduxjs/toolkit";
import { NumericFormat } from "react-number-format";
export function ProductSelect(_param) {
    var productRow = _param.productRow, setProductRow = _param.setProductRow, addProductRow = _param.addProductRow, optionsWarehouse = _param.optionsWarehouse, optionsMstVat = _param.optionsMstVat, values = _param.values, props = _object_without_properties(_param, [
        "productRow",
        "setProductRow",
        "addProductRow",
        "optionsWarehouse",
        "optionsMstVat",
        "values"
    ]);
    var _useState = _sliced_to_array(useState([]), 2), data = _useState[0], setData = _useState[1];
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState1 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState1[0], setOptionsGroupOfSuplier = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState2[0], setSelectedGroupOfSuplierID = _useState2[1];
    var _useState3 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState3[0], setGroupOfSupplier = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), distributorgroup = _useState4[0], setDistributorgroup = _useState4[1];
    // const getData = () => {
    //   fetch("/json/product.json")
    //     .then((response) => response.json())
    //     .then((result) => {
    //       setData(result);
    //     })
    //     .catch((error) => console.log("error", error));
    // };
    // useEffect(() => {
    //   getData();
    // }, []);
    var _useState5 = _sliced_to_array(useState(""), 2), filterText = _useState5[0], setFilterText = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), filteredItems = _useState6[0], setFilteredItems = _useState6[1];
    var columnsd = [
        {
            field: "productCode",
            headerName: "รหัสสินค้า",
            width: 160,
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("div", {
                        style: {
                            color: "#565DFF"
                        },
                        children: row.productCode
                    })
                });
            }
        },
        {
            field: "productName",
            headerName: "ชื่อสินค้า",
            width: 250,
            flex: 1,
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsxs("div", {
                        children: [
                            row.productName,
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx("span", {
                                className: "fs-12",
                                style: {
                                    color: "#F26F3A"
                                },
                                children: row.productBarcode
                            }),
                            " "
                        ]
                    })
                });
            }
        },
        {
            field: "productCategory",
            headerName: "หมวดหมู่",
            width: 150,
            sortable: true
        },
        {
            field: "productBrand",
            headerName: "แบรนด์",
            width: 150,
            sortable: true
        },
        {
            field: "sellPrice",
            headerName: "ราคาขาย",
            width: 110,
            cellClassName: "d-flex justify-content-end",
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 4,
                        fixedDecimalScale: true,
                        value: row.sellPrice
                    })
                });
            }
        },
        {
            field: "dimProduct",
            headerName: "ราคาซื้อ",
            width: 110,
            cellClassName: "d-flex justify-content-end text-danger",
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 4,
                        fixedDecimalScale: true,
                        value: getUnitCost(row)
                    })
                });
            }
        },
        {
            field: "productUnit",
            headerName: "หน่วย",
            sortable: true,
            width: 160
        },
        {
            field: "productRatioUnit",
            headerName: "อัตราส่วน",
            width: 110,
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        "1X",
                        row.productRatioUnit
                    ]
                });
            }
        }
    ];
    var getAllMasterMainCategoryReducer = useAppSelector(function(state) {
        return state.getAllMasterMainCategoryReducer;
    });
    var getAllMasterBrandReducer = useAppSelector(function(state) {
        return state.getAllMasterBrandReducer;
    });
    var _useState7 = _sliced_to_array(useState([]), 2), optionsMasterMainCategory = _useState7[0], setOptionsMasterMainCategory = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), optionsMasterBrand = _useState8[0], setOptionsMasterBrand = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        category_id: "",
        brand_id: ""
    }), 2), optionFiltered = _useState9[0], setOptionFiltered = _useState9[1];
    var loadAllMsts = function() {
        dispatch(getAllMasterBrand());
        dispatch(getAllMasterMainCategory());
    };
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMasterBrandReducer.isFetching || getAllMasterMainCategoryReducer.isFetching);
        if (getAllMasterBrandReducer.data) {
            setOptionsMasterBrand(getAllMasterBrandReducer.data.data.map(function(item) {
                return _object_spread_props(_object_spread({}, defaultOption), {
                    label: item.name,
                    value: item.id
                });
            }));
        }
        if (getAllMasterMainCategoryReducer.data) {
            setOptionsMasterMainCategory(getAllMasterMainCategoryReducer.data.data.map(function(item) {
                return _object_spread_props(_object_spread({}, defaultOption), {
                    label: item.name,
                    value: item.id
                });
            }));
        }
    }, [
        getAllMasterBrandReducer,
        getAllMasterMainCategoryReducer
    ]);
    var getAllProductPriceReducer = useAppSelector(function(state) {
        return state.getAllProductPriceReducer;
    });
    var getAllProductPriceData = function() {
        var searchText = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        var queryParams = _object_spread(_object_spread_props(_object_spread({
            isWithOutDeleted: "true"
        }, !!optionFiltered.brand_id || !!optionFiltered.category_id || searchText.trim() != "" ? {} : {
            limit: 20
        }), {
            searchText: searchText.trim(),
            brandID: optionFiltered.brand_id,
            categoryID: optionFiltered.category_id
        }), values.dim_supplier_information_id && {
            supInfoID: values.dim_supplier_information_id
        });
        dispatch(getAllProductPrice({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var debouncedSearch = useMemo(function() {
        return debounce(function(searchText) {
            getAllProductPriceData(searchText);
        }, 300);
    }, [
        filterText
    ]);
    useEffect(function() {
        if (getAllProductPriceReducer.data && getAllProductPriceReducer.data.data) {
            var datas = getAllProductPriceReducer.data.data;
            // console.log(datas);
            var mappingData = mappingProductPriceData({
                productPrices: datas,
                values: values,
                optionsWarehouse: optionsWarehouse,
                optionsMstVat: optionsMstVat
            });
            setData(mappingData ? mappingData : []);
            var filteredItems = mappingData.filter(function(item) {
                return item.productCode && item.productCode.toLowerCase().includes(filterText.trim().toLowerCase()) || item.productName && item.productName.toLowerCase().includes(filterText.trim().toLowerCase()) || item.productBarcode && item.productBarcode.toLowerCase().includes(filterText.trim().toLowerCase());
            });
            setFilteredItems(filteredItems);
        }
    }, [
        getAllProductPriceReducer
    ]);
    useEffect(function() {
        debouncedSearch(filterText);
    }, [
        filterText
    ]);
    useEffect(function() {
        getAllProductPriceData(filterText);
    }, [
        optionFiltered
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center  mb-3 flex-wrap",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "mb-2 me-3",
                        style: {
                            width: "220px"
                        },
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "form-st-3 sm pb-1",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "หมวดหมู่"
                                }),
                                /*#__PURE__*/ _jsx(Select, {
                                    as: "select",
                                    name: "",
                                    onChange: function(e) {
                                        setOptionFiltered(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                category_id: e.value
                                            });
                                        });
                                    },
                                    className: "w-100 select-st-1",
                                    options: optionsMasterMainCategory,
                                    placeholder: "",
                                    value: optionsMasterMainCategory.filter(function(item) {
                                        return item.value === optionFiltered.category_id;
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mb-2 me-auto",
                        style: {
                            width: "220px"
                        },
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "form-st-3 sm pb-1",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "แบรนด์สินค้า"
                                }),
                                /*#__PURE__*/ _jsx(Select, {
                                    as: "select",
                                    name: "",
                                    onChange: function(e) {
                                        setOptionFiltered(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                brand_id: e.value
                                            });
                                        });
                                    },
                                    className: "w-100 select-st-1",
                                    options: optionsMasterBrand,
                                    placeholder: "",
                                    value: optionsMasterBrand.filter(function(item) {
                                        return item.value === optionFiltered.brand_id;
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "me-3 mb-2",
                        children: /*#__PURE__*/ _jsx("input", {
                            type: "text",
                            className: "form-control form-st-4",
                            placeholder: "ค้นหา",
                            onChange: function(e) {
                                return setFilterText(e.target.value);
                            },
                            value: filterText
                        })
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: function() {
                            setFilterText("");
                            setOptionFiltered({
                                category_id: "",
                                brand_id: ""
                            });
                        },
                        type: "button",
                        className: "btn btn btn-st-v1 mb-2 px-4",
                        children: "ล้างค่าการค้นหา"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    width: "100%"
                },
                children: /*#__PURE__*/ _jsx(DataGrid, {
                    getRowId: function(row) {
                        return row.productID;
                    },
                    getRowHeight: function() {
                        return "auto";
                    },
                    rows: filteredItems,
                    autoHeight: true,
                    columns: columnsd,
                    initialState: {
                        pagination: {
                            paginationModel: {
                                pageSize: 10
                            }
                        }
                    },
                    pageSizeOptions: [
                        10,
                        20,
                        30
                    ],
                    checkboxSelection: true,
                    disableRowSelectionOnClick: true,
                    slotProps: {
                        pagination: {
                            labelRowsPerPage: "จำนวนรายการต่อหน้า"
                        }
                    },
                    disableMultipleRowSelection: true,
                    sx: {
                        fontFamily: "Sarabun",
                        fontSize: "16px",
                        ".MuiDataGrid-columnHeaderTitle": {
                            fontFamily: "Sarabun",
                            fontSize: "16px"
                        },
                        "& .MuiDataGrid-virtualScrollerRenderZone": {
                            transform: "unset !important"
                        }
                    },
                    onRowSelectionModelChange: function(ids) {
                        var selectedIDs = new Set(ids);
                        var selectedRows = filteredItems.filter(function(row) {
                            return selectedIDs.has(row.productID);
                        });
                        // console.log(selectedRows.length);
                        if (selectedRows.length > 0) {
                            setProductRow(function(productRow) {
                                var _selectedRows__dimProduct;
                                var warehouseID = values.dim_warehouse_id;
                                var warehouse = optionsWarehouse.find(function(item) {
                                    return values.dim_warehouse_id === item.value;
                                });
                                var warehouseName = warehouse ? warehouse.label : "";
                                var vatByMstCatPrice = getVatByMstCategoryPrice(values.dim_mst_price_category_id, selectedRows[selectedRows.length - 1].dim_mst_vat_id, selectedRows[selectedRows.length - 1].vat);
                                var lastSelectedRow = _object_spread_props(_object_spread({}, selectedRows[selectedRows.length - 1]), {
                                    rowID: nanoid(),
                                    supplierCode: (_selectedRows__dimProduct = selectedRows[selectedRows.length - 1].dimProduct) === null || _selectedRows__dimProduct === void 0 ? void 0 : _selectedRows__dimProduct.supplier_code,
                                    warehouseID: warehouseID,
                                    warehouseName: warehouseName,
                                    dim_mst_vat_id: vatByMstCatPrice.dim_mst_vat_id,
                                    vat: vatByMstCatPrice.vat
                                });
                                // Check if productRow contains a row with null productID
                                var existingRowIndex = productRow.findIndex(function(row) {
                                    return !row.productID;
                                });
                                if (existingRowIndex !== -1) {
                                    // Replace the row with null productID
                                    var updatedRows = _to_consumable_array(productRow);
                                    updatedRows[existingRowIndex] = lastSelectedRow;
                                    return updatedRows;
                                } else {
                                    // Append the new row if no match found
                                    return _to_consumable_array(productRow).concat([
                                        lastSelectedRow
                                    ]);
                                }
                            });
                        // addProductRow(1);
                        }
                    }
                })
            })
        ]
    });
}
